import script from "./Label.vue?vue&type=script&setup=true&lang=ts"
export * from "./Label.vue?vue&type=script&setup=true&lang=ts"

import "./Label.vue?vue&type=style&index=0&id=1ea58a56&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ea58a56"]])

export default __exports__